<div class="order-editing-container" data-ph-mask>
  @if ((shopService.shop$ | async).metadata?.orderEditingEnabled) {
    <ng-template pdqHeaderContent>
      <div class="order-editing-header">
        <div class="order-editing-header__title">
          <feature-mode-picker [control]="orderEditingService.form.get('state')"></feature-mode-picker>
        </div>
        <div class="order-editing-header__actions">
          @if (!orderEditingService.updateRequired() && !orderEditingService.form.pristine) {
            <pdq-button label="Cancel" variant="tertiary" (onClick)="onCancel()"> </pdq-button>
          }
          <pdq-button
            label="Save"
            variant="primary"
            (onClick)="onSave()"
            [loading]="saveLoading"
            [disabled]="
              orderEditingService.updateRequired() ||
              orderEditingService.form.invalid ||
              orderEditingService.form.pristine
            ">
          </pdq-button>
        </div>
      </div>
    </ng-template>
    <div class="content">
      <order-editing-header></order-editing-header>
      <div class="content__body" [class.content__body--full-width]="orderEditingService.hidePreview()">
        <order-editing-form></order-editing-form>
        @if (!orderEditingService.hidePreview()) {
          <order-editing-preview></order-editing-preview>
        }
      </div>
    </div>
  } @else {
    <pdq-banner
      variant="regular"
      [closable]="false"
      bannerTitle="This feature lets your customers make post-purchase changes like updating product variants, addresses, and more—without contacting support.
      👉 Contact PDQ Customer Success to get started.">
    </pdq-banner>
  }
</div>
